import { connect, mapProps, mapReadPretty } from '@formily/react';
import { Input as AntdInput, TextArea as AntdTextArea } from 'antd-mobile';
import { isValid } from '@formily/shared';
import { PreviewText } from '../preview-text';
export const Input = connect(AntdInput, mapProps((props) => {
    return {
        value: isValid(props.value) ? props.value : '',
    };
}), mapReadPretty(PreviewText.Input));
Input.TextArea = connect(AntdTextArea, mapProps((props) => {
    return {
        value: isValid(props.value) ? props.value : '',
    };
}), mapReadPretty(PreviewText.Input));
export default Input;
//# sourceMappingURL=index.js.map